// demo-webscm 2026 11 02 / ODOO-350612 (навигатор интерфейса): геометрия свободного окна — ОБЩИЙ код для Free-виджета (Widget.vue
// popoutDragStart / popoutDragMove) и правого дока навигатора в режиме «вільне вікно» (NavigatorDock.vue). Вынесено из Widget.vue без изменения
// поведения: те же формулы (move — сдвиг left/top; resize — по сторонам режима с компенсацией для север/запад при упоре в минимум), те же
// минимумы 320×180 и та же починка стартового ректа (left/top/width/height из style, иначе из getBoundingClientRect и проставляются в style).
// Чистые функции без DOM — для юнит-тестов (tests/unit/freeWindow.test.mjs); с DOM — только freeWindow_startRect / freeWindow_apply / freeWindow_listen.
const num = (v) => Number.parseInt(v, 10)

export const FREE_WINDOW_MIN_W = 320
export const FREE_WINDOW_MIN_H = 180
export const FREE_WINDOW_MODES = ['move', 'top', 'bottom', 'left', 'right', 'top-right', 'top-left', 'bottom-right', 'bottom-left']

// стартовый рект окна из style (px) с дозаполнением из rect; недостающие left/top/width/height записываются в el.style — дальше всё консистентно
export function freeWindow_startRect(el, rect) {
    const r = rect || el.getBoundingClientRect()
    const startLeft = num(el.style.left), startTop = num(el.style.top)
    const startW = num(el.style.width) || r.width
    const startH = num(el.style.height) || r.height
    const left = Number.isFinite(startLeft) ? startLeft : Math.round(r.left)
    const top = Number.isFinite(startTop) ? startTop : Math.round(r.top)
    if (!Number.isFinite(startLeft)) el.style.left = left + 'px'
    if (!Number.isFinite(startTop)) el.style.top = top + 'px'
    if (!el.style.width) el.style.width = Math.round(r.width) + 'px'
    if (!el.style.height) el.style.height = Math.round(r.height) + 'px'
    return { left, top, width: startW, height: startH }
}

// состояние жеста: координаты старта, режим, стартовый рект
export function freeWindow_dragState(start, sx, sy, mode = 'move') {
    return { sx, sy, mode: FREE_WINDOW_MODES.includes(mode) ? mode : 'move',
        startLeft: start.left, startTop: start.top, startW: start.width, startH: start.height, lastEvent: null, raf: null }
}

// новый рект по смещению курсора (dx, dy) — чистая функция; opts.minW / minH — минимумы (по умолчанию как у Free-виджета)
export function freeWindow_nextRect(d, dx, dy, opts = {}) {
    const MIN_W = opts.minW ?? FREE_WINDOW_MIN_W
    const MIN_H = opts.minH ?? FREE_WINDOW_MIN_H
    if (d.mode === 'move') return { left: Math.round(d.startLeft + dx), top: Math.round(d.startTop + dy), width: null, height: null }
    let left = d.startLeft, top = d.startTop, w = d.startW, h = d.startH
    const hasTop = d.mode.includes('top'), hasBottom = d.mode.includes('bottom')
    const hasLeft = d.mode.includes('left'), hasRight = d.mode.includes('right')
    if (hasRight) w = d.startW + dx
    if (hasBottom) h = d.startH + dy
    if (hasLeft) { w = d.startW - dx; left = d.startLeft + dx }
    if (hasTop) { h = d.startH - dy; top = d.startTop + dy }
    if (w < MIN_W) { if (hasLeft) left -= (MIN_W - w); w = MIN_W }
    if (h < MIN_H) { if (hasTop) top -= (MIN_H - h); h = MIN_H }
    return { left: Math.round(left), top: Math.round(top), width: Math.round(w), height: Math.round(h) }
}

// применить рект к style (null — поле не трогать: у move ширина/высота не меняются)
export function freeWindow_apply(el, r) {
    if (!el || !r) return
    if (r.left !== null && r.left !== undefined) el.style.left = r.left + 'px'
    if (r.top !== null && r.top !== undefined) el.style.top = r.top + 'px'
    if (r.width !== null && r.width !== undefined) el.style.width = r.width + 'px'
    if (r.height !== null && r.height !== undefined) el.style.height = r.height + 'px'
}

// слушатели жеста на window: pointermove / pointerup / pointercancel (+ глушение touchmove у тача — иначе браузер отберёт жест); возвращает off()
export function freeWindow_listen(win, e, { move, end }) {
    const touch = e?.pointerType === 'touch' ? (te) => te.preventDefault() : null
    win.addEventListener('pointermove', move, { passive: false })
    win.addEventListener('pointerup', end, { passive: false })
    win.addEventListener('pointercancel', end, { passive: false })
    if (touch) win.addEventListener('touchmove', touch, { passive: false })
    return () => {
        win.removeEventListener('pointermove', move)
        win.removeEventListener('pointerup', end)
        win.removeEventListener('pointercancel', end)
        if (touch) win.removeEventListener('touchmove', touch)
    }
}

// рект, целиком видимый в окне vw×vh (окно навигатора не должно уехать за экран; у виджетов этим занимается store.checkPopout)
export function freeWindow_clamp(r, vw, vh, margin = 8) {
    const width = Math.min(r.width, Math.max(FREE_WINDOW_MIN_W, vw - margin * 2))
    const height = Math.min(r.height, Math.max(FREE_WINDOW_MIN_H, vh - margin * 2))
    const left = Math.min(Math.max(margin, r.left), Math.max(margin, vw - width - margin))
    const top = Math.min(Math.max(margin, r.top), Math.max(margin, vh - height - margin))
    return { left, top, width, height }
}
